import React from "react";
import { Link } from "react-router-dom";

const BRAND_YELLOW = "#ffc107";

const ConsultationServiceSingle = (props) => {
  const {
    serviceClass,
    serviceImg,
    serviceTitle,
    serviceDescription,
  } = props;

  return (
    <>
      <style>{`
        .consultation-arrow-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #222;
          color: #fff;
          font-size: 20px;
          text-decoration: none;
          border: none;
          transition: background 0.2s, color 0.2s;
          position: relative;
          overflow: hidden;
        }
        .consultation-arrow-btn .arrow {
          display: inline-block;
          transition: transform 0.2s, color 0.2s;
        }
        .consultation-arrow-btn:hover {
          background: ${BRAND_YELLOW};
          color: #111;
        }
        .consultation-arrow-btn:hover .arrow {
          color: #111;
          transform: translateX(6px);
        }
      `}</style>
      <div
        className={serviceClass}
        style={{
          display: "flex",
          background: "#fff",
          borderRadius: "12px",
          boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
          overflow: "hidden",
          minWidth: "350px",
          maxWidth: "600px",
          flex: 1,
          alignItems: "stretch",
          padding: 0,
        }}
      >
        <div style={{ flex: "0 0 180px", width: "180px", height: "100%", overflow: "hidden", display: "flex" }}>
          <img
            src={serviceImg}
            alt={serviceTitle}
            style={{ width: "180px", height: "100%", objectFit: "cover", display: "block" }}
          />
        </div>
        <div style={{ flex: 1, padding: "24px 24px 24px 32px", display: "flex", flexDirection: "column", justifyContent: "center", height: "100%" }}>
          <h3 style={{ fontSize: "1.25rem", fontWeight: 600, marginBottom: 8 }}>{serviceTitle}</h3>
          <p style={{ fontSize: "1rem", color: "#555", marginBottom: 16 }}>
            {serviceDescription && serviceDescription.length > 120
              ? `${serviceDescription.substring(0, 120)}...`
              : serviceDescription}
          </p>
          <div style={{ display: "flex", justifyContent: "flex-end", flex: 1, alignItems: "flex-end" }}>
            <Link
              to="/consultation"
              className="consultation-arrow-btn"
              title="Request Demo"
              style={{ marginTop: 8 }}
            >
              <span className="arrow">&#8594;</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsultationServiceSingle; 